// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3KvWl","rootSuccess":"CompleteLink_rootSuccess__3fveU","rootFailure":"CompleteLink_rootFailure__28g2z","isDisabled":"CompleteLink_isDisabled__1kRpQ"};